import Api from '@/api'
// 模拟数据
// import wgjbDetail from '../mock/wgjbDetail.json'

const dialogLogic = {
  data() {
    return {
      // 一层参数
      dialogTitle: '',
      miTableBtn: {},
      rowData: {},
      // 二层参数 点击一层弹窗的时候会有
      sureBtnClickContent: undefined
    }
  },
  methods: {
    onShowDialogFromTableBtn(d, target) {
      console.log('===============', d, target)
      const vm = this
      vm.dialogTitle = target.title
      // vm.rowData = d
      vm.miTableBtn = target
      if (target.showType === 'dialog-text' && target.children && target.children.length) {
        // 一层弹窗按钮兼容，数据 + 配置
        if (vm.miTableBtn.sureRelation) {
          if (vm.rowData[vm.miTableBtn.sureRelation]) {
            vm.miTableBtn.isShowSureBtn = false
          } else {
            vm.miTableBtn.isShowSureBtn = true
          }
        }
        if (vm.miTableBtn.id === '100-tb-1') {
          vm.rowData = d
          if (vm.miTableBtn.sureRelation) {
            if (vm.rowData[vm.miTableBtn.sureRelation] || !vm.checkUserAuth(72, vm.miTableBtn.sureBtnPermissionId)) {
              vm.miTableBtn.isShowSureBtn = false
            } else {
              vm.miTableBtn.isShowSureBtn = true
            }
          }
        }
        if(vm.kaoheType==1||vm.kaoheType==2){
          vm.rowData = d
          vm.handleShowDialog()
          return
        }
        if (vm.miTableBtn.id === '660-tb-1') {
          vm.rowData = d
        }
      } else if (target.showType === 'dialog-text2') {
        // 删除列表获取详情
        vm.rowData = d
      } else if (target.showType === 'dialog-form') {
        vm.rowData = d
        vm.handleShowDialog()
        return
      }

      // 接口获取详情
      if (target.api) {
        // 接口请求详情
        const params = {
          taskId: d.id,
          selfAreaId: vm.selfAreaId
        }
        vm.getApiPre(params, target.api, vm.handleShowDialog)
      } else {
        if (!vm.rowData || !vm.rowData.id) {
          vm.rowData = d
          // 转换数据的
          if (vm.miTableBtn && vm.miTableBtn.initDetail) {
            this[vm.miTableBtn.initDetail]()
          }
          // 一层弹窗按钮兼容，数据 + 配置
          if (vm.miTableBtn.sureRelation) {
            // 关联值的取值判断
            if (vm.rowData[vm.miTableBtn.sureRelation]) {
              // 权限判断
              if (vm.checkUserAuth(72, vm.miTableBtn.sureBtnPermissionId)) {
                vm.miTableBtn.isShowSureBtn = true
              } else {
                vm.miTableBtn.isShowSureBtn = false
              }
              if (vm.miTableBtn.cancelBtnText && vm.checkUserAuth(72, vm.miTableBtn.cancelBtnPermissionId)) {
                vm.miTableBtn.isShowCancelBtn = true
              } else {
                vm.miTableBtn.isShowCancelBtn = false
              }
            } else {
              vm.miTableBtn.isShowSureBtn = false
              vm.miTableBtn.isShowCancelBtn = false
            }
          }
        }
        // 直接展示
        vm.handleShowDialog()
      }
    },
    handleShowDialog() {
      this.$refs['w-dialog'].onShowDialog()
    },
    onCloseDialog(type) {
      const vm = this
      if (type === 1 && vm.miTableBtn && vm.miTableBtn.cancelBtnClickContent) {
        vm.sureBtnClickContent = vm.miTableBtn.cancelBtnClickContent
        setTimeout(() => {
          vm.$refs['w-two-dialog'].onShowDialog()
        }, 0)
        return
      }
      vm.dialogTitle = ''
      vm.miTableBtn = {}
      vm.rowData = {}
      vm.$refs['w-dialog'].onCloseDialog()
    },
    onSureDialog() {
      console.log('onSureDialog')
      if (this.miTableBtn && this.miTableBtn.fn) {
        this[this.miTableBtn.fn] && this[this.miTableBtn.fn](this.miTableBtn.delType)
      }
    },
    addReport() {
      console.log('addReport', this.$refs)
      const vm = this
      const pid = this.miTableBtn.id
      const data = {}
      for (const key in this.$refs) {
        if (key.indexOf(pid) > -1 && this.$refs[key].length) {
          const vc = this.$refs[key][0]
          const name = vc.params.label
          const ikey = vc.params.key
          const value = vc.getValue()
          console.log(name, ikey, value)
          if (value && ikey === 'area') {
            if (Number(value.radio) === 1) {
              // data.radio = value.radio
            } else if (Number(value.radio) === 2) {
              // data.radio = value.radio
              if (!value[ikey] || !value[ikey].provience) {
                return this.$message.error('请选择适用范围: 省市区县')
              } else if (!value[ikey] || !value[ikey].city) {
                return this.$message.error('请选择适用范围: 市区县')
              } else if (!value[ikey] || !value[ikey].area) {
                return this.$message.error('请选择适用范围: 区县')
              } else {
                data.provinceId = value[ikey].provience
                data.cityId = value[ikey].city
                data.regionId = value[ikey].area
              }
            }
          } else if (value && (value[ikey] || value[ikey] === 0) && ikey !== 'area') {
            data[ikey] = value[ikey]
          } else {
            // return this.$message.error('请填写' + name.replace(':', '').replace('：', ''))
          }
        }
      }
      data.userId = vm.user.id
      const params = {
        selfAreaId: vm.selfAreaId
      }
      console.log(params,data);
      // Api.fetchApiPost(data, params, vm.miTableBtn.api)
      //   .then(res => {
      //     // 刷新页面
      //     if (res && res.code === 200) {
      //       vm.$message.success('公告发布成功！')
      //       vm.onCloseDialog()
      //       const currTab = vm.configJs.find(item => item.active)
      //       vm.refreshPage(currTab)
      //     } else {
      //       vm.$message.warning(res && res.message)
      //     }
      //   })
      //   .catch(err => {
      //     console.log('addWGType', err)
      //   })
    },
    // 公告
    addGgtz() {
      console.log('addGgtz', this.$refs)
      const vm = this
      const pid = this.miTableBtn.id
      const data = {}
      for (const key in this.$refs) {
        if (key.indexOf(pid) > -1 && this.$refs[key].length) {
          const vc = this.$refs[key][0]
          const name = vc.params.label
          const ikey = vc.params.key
          const value = vc.getValue()
          console.log(name, ikey, value)
          if (value && ikey === 'area') {
            if (Number(value.radio) === 1) {
              // data.radio = value.radio
            } else if (Number(value.radio) === 2) {
              // data.radio = value.radio
              if (!value[ikey] || !value[ikey].provience) {
                return this.$message.error('请选择适用范围: 省市区县')
              } else if (!value[ikey] || !value[ikey].city) {
                return this.$message.error('请选择适用范围: 市区县')
              } else if (!value[ikey] || !value[ikey].area) {
                return this.$message.error('请选择适用范围: 区县')
              } else {
                data.provinceId = value[ikey].provience
                data.cityId = value[ikey].city
                data.regionId = value[ikey].area
              }
            }
          } else if (value && (value[ikey] || value[ikey] === 0) && ikey !== 'area') {
            data[ikey] = value[ikey]
          } else {
            return this.$message.error('请填写' + name.replace(':', '').replace('：', ''))
          }
        }
      }
      data.userId = vm.user.id
      const params = {
        selfAreaId: vm.selfAreaId
      }
      Api.fetchApiPost(data, params, vm.miTableBtn.api)
        .then(res => {
          // 刷新页面
          if (res && res.code === 200) {
            vm.$message.success('公告发布成功！')
            vm.onCloseDialog()
            const currTab = vm.configJs.find(item => item.active)
            vm.refreshPage(currTab)
          } else {
            vm.$message.warning(res && res.message)
          }
        })
        .catch(err => {
          console.log('addWGType', err)
        })
    },
    // 一层 弹窗事件处理
    // 违规举报 - 表格按钮弹窗里面的确定或者关闭事件 - 自定义函数 - 与miBicycylejs对应
    wgjbShowDetail() {
      const vm = this
      if (vm.miTableBtn.sureBtnClickContent) {
        vm.sureBtnClickContent = vm.miTableBtn.sureBtnClickContent
        setTimeout(() => {
          vm.$refs['w-two-dialog'].onShowDialog()
        }, 0)
      }
    },
    ruleDel() {
      console.log('ruleDel')
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId
      }
      console.log(this.miTableBtn)
      const url = (this.miTableBtn.id == '667-tb-2' ? Api.deleteRuleMac : Api.deleteRule)
      url(vm.rowData.id, params).then(res => {
        // 刷新页面
        console.log(res)
        if (res && res.code === 200) {
          vm.$message.success('删除成功！')
          vm.onCloseDialog()
          const currTab = vm.configJs.find(item => item.active)
          vm.refreshPage(currTab)
        } else {
          vm.$message.warning(res && res.message)
        }
      })
        .catch(err => {
          console.log('the ruleDel has problem: ', err)
        })
    },
    wcclDel() {
      console.log('wcclDel')
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId
      }
      var url = Api.deleteBikeNot
      var data = {
        bikeIds: vm.rowData.bikeId
      }
      if (vm.rowData.bikeMac) {
        url = Api.deleteBikeNotMac
        data = {
          bikeMacs: vm.rowData.bikeMac
        }
      }
      url(data, params).then(res => {
        // 刷新页面
        console.log(res)
        if (res && res.code === 200) {
          vm.$message.success('删除成功！')
          vm.onCloseDialog()
          const currTab = vm.configJs.find(item => item.active)
          this.$nextTick(() => {
            this.refreshPage(currTab)
          })
        } else {
          vm.$message.warning(res && res.message)
        }
      })
        .catch(err => {
          console.log('the wcclDel has problem: ', err)
        })
    },
    wgjbDel() {
      console.log('wgjbDel')
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId
      }
      const data = {
        ids: vm.rowData.id
      }
      vm.postApiPre(data, params, '/api/miApp/deleteReports')
        .then(res => {
          // 刷新页面
          console.log(res)
          if (res && res.code === 200) {
            vm.$message.success('违规举报删除成功！')
            vm.onCloseDialog()
            const currTab = vm.configJs.find(item => item.active)
            vm.refreshPage(currTab)
          } else {
            vm.$message.warning(res && res.message)
          }
        })
        .catch(err => {
          console.log('the wgjbDel has problem: ', err)
        })
    },
    delClockSite() {
      console.log('clockSiteDel')
      const vm = this
      var data = {
        id: vm.rowData.id
      }
      Api.delClockSiteById(vm.selfAreaId, data).then(res => {
        // 刷新页面
        console.log(res)
        if (res && res.code === 200) {
          vm.$message.success('考勤站点删除成功！')
          vm.onCloseDialog()
          const currTab = vm.configJs.find(item => item.active)
          this.$nextTick(() => {
            this.refreshPage(currTab)
          })
        } else {
          vm.$message.warning(res && res.message)
        }
      }).catch(err => {
        console.log('the clockSiteDel has problem: ', err)
      })
    },
    // 二层 弹窗事件处理
    onTwoCloseDialog() {
      if (this.sureBtnClickContent && this.sureBtnClickContent.failFn) {
        this[this.sureBtnClickContent.failFn] && this[this.sureBtnClickContent.failFn]()
      } else {
        this.$refs['w-two-dialog'].onCloseDialog()
      }
    },
    onSureTwoDialog() {
      if (this.sureBtnClickContent && this.sureBtnClickContent.fn) {
        this[this.sureBtnClickContent.fn] && this[this.sureBtnClickContent.fn]()
      } else {
        this.$refs['w-two-dialog'].onCloseDialog()
      }
    },
    wgclTwoSubmit() {
      console.log('wgclTwoSubmit,违规处理弹窗的确定回复')
      const vm = this
      let checked = false
      if (vm.sureBtnClickContent && vm.sureBtnClickContent.children) {
        // 检验
        checked = vm.sureBtnClickContent.children.some(item => item.require && !item.value)
        if (checked) {
          const curr = vm.sureBtnClickContent.children.find(item => item.require && !item.value)
          vm.$message.error(curr.errText)
          return null
        }
        // 取值
        const data = {}
        vm.sureBtnClickContent.children.forEach(item => {
          data[item.key] = item.value
        })
        console.log('data', data)
        data.id = vm.rowData.id
        const params = {
          selfAreaId: vm.selfAreaId
        }
        vm.postApiPre(data, params, vm.sureBtnClickContent.api)
          .then(res => {
            // 二层重置
            vm.onTwoCloseDialog()
            // 一层重置
            vm.onCloseDialog()
            // 刷新页面
            const currTab = vm.configJs.find(item => item.active)
            vm.refreshPage(currTab)
          })
      }
    },
    wgclTwoCancel() {
      console.log('wgclTwoCancel,违规处理弹窗的取消')
      if (this.sureBtnClickContent && this.sureBtnClickContent.children) {
        this.sureBtnClickContent.children.forEach(item => {
          // 数据清理
          item.value = ''
          // 组件清理
          if (this.$refs && this.$refs[item.id] && this.$refs[item.id][0].reset) {
            this.$refs[item.id][0].reset()
          }
        })
        this.sureBtnClickContent = undefined
        this.$refs['w-two-dialog'].onCloseDialog()
      }
    },
    towDialogValueChange(d) {
      // 输入框联动输入写入 js
      const curr = this.sureBtnClickContent.children.find(item => item.id === d.id)
      curr.value = d.value
    },
    // 角色管理 - 站点角色 / 调度员 - 删除
    jsgl_zdjs_del() {
      const vm = this
      vm.getApiPre({
        id: vm.rowData.id,
        selfAreaId: vm.selfAreaId
      }, '/api/miApp/deleteMiUser')
        .then(res => {
          // 刷新页面
          if (res && res.code === 200) {
            vm.$message.success('角色删除成功！')
            vm.onCloseDialog()
            const currTab = vm.configJs.find(item => item.active)
            vm.refreshPage(currTab)
          } else {
            vm.$message.warning(res && res.message)
          }
        })
        .catch(err => {
          console.log('the jsgl_zdjs_del has problem: ', err)
        })
    },
    // 角色管理 - 审核列表 - 站点角色 / 调度员 - 通过
    shlb_zdgl_pass_pre(target) {
      const vm = this
      if (vm.multipleSelection && !vm.multipleSelection.length) {
        return vm.$message.error('请选择审核角色！')
      }
      vm.onShowDialogFromTableBtn(null, target)
    },
    shlb_zdgl_pass() {
      const vm = this
      // 批量处理  piliang === 1
      const params = {
        selfAreaId: vm.selfAreaId
      }
      const data = {
        roleIds: vm.miTableBtn.piliang === 1 ? this.multipleSelection.join(',') : vm.rowData.id
      }
      vm.postApiPre(data, params, '/api/miApp/batchPassRoleApply')
        .then(res => {
          // 刷新页面
          if (res && res.code === 200) {
            const txt = vm.miTableBtn.piliang === 1 ? '批量审核通过成功！' : '审核通过成功！'
            vm.$message.success(txt)
            vm.onCloseDialog()
            const currTab = vm.configJs.find(item => item.active)
            vm.refreshPage(currTab)
          } else {
            vm.$message.warning(res && res.message)
          }
        })
        .catch(err => {
          console.log('the shlb_zdgl_pass has problem: ', err)
        })
    },
    // 角色管理 - 审核列表 - 站点角色 / 调度员 - 拒绝
    shlb_zdgl_reject_pre(target) {
      const vm = this
      if (!this.multipleSelection.length) {
        return vm.$message.error('请选择审核角色！')
      }
      vm.onShowDialogFromTableBtn(null, target)
    },
    shlb_zdgl_reject() {
      console.log('角色管理 - 审核列表 - 站点角色 / 调度员 - 拒绝')
      const vm = this
      const params = {
        selfAreaId: vm.selfAreaId
      }
      const data = {
        roleIds: vm.miTableBtn.piliang === 1 ? this.multipleSelection.join(',') : vm.rowData.id,
        reason: ''
      }
      // 检验
      for (const btn of this.miTableBtn.children) {
        if (this.$refs[btn.id] && this.$refs[btn.id][0]) {
          const vmCom = this.$refs[btn.id][0]
          const v = vmCom.getValue()
          const vmComParams = vmCom.params
          if (vmComParams.require && !v) {
            return vm.$message.error(vmComParams.errText)
          } else {
            data.reason = v[vmComParams.key]
          }
        }
      }
      vm.postApiPre(data, params, '/api/miApp/batchRefuseRoleApply')
        .then(res => {
          // 刷新页面
          if (res && res.code === 200) {
            const txt = vm.miTableBtn.piliang === 1 ? '审核批量拒绝成功！' : '审核拒绝成功！'
            vm.$message.success(txt)
            vm.onCloseDialog()
            const currTab = vm.configJs.find(item => item.active)
            vm.refreshPage(currTab)
          } else {
            vm.$message.warning(res && res.message)
          }
        })
        .catch(err => {
          console.log('the shlb_zdgl_reject has problem: ', err)
        })
    },
    getApiPre(params, api, fn) {
      const vm = this
      return new Promise((resolve, reject) => {
        Api.fetchApiGet(params, api)
          .then(res => {
            vm.rowData = res.data
            fn && fn()
            resolve(res)
          })
          .catch(err => {
            console.log('getApiPre', err)
            reject(err)
          })
      })
    },
    postApiPre(data, params, api, fn) {
      const vm = this
      return new Promise((resolve, reject) => {
        Api.fetchApiPost(data, params, api)
          .then(res => {
            vm.rowData = res.data
            fn && fn()
            resolve(res)
          })
          .catch(err => {
            console.log('postApiPre', err)
            reject(err)
          })
      })
    },
    // 删除公告通知
    noticeDel() {
      const vm = this
      Api.deleteNotice(vm.rowData.id, vm.selfAreaId)
        .then(res => {
          // 刷新页面
          console.log(res)
          if (res && res.code === 200) {
            vm.$message.success('公告通知删除成功！')
            vm.onCloseDialog()
            const currTab = vm.configJs.find(item => item.active)
            vm.refreshPage(currTab)
          } else {
            vm.$message.warning(res && res.message)
          }
        })
        .catch(err => {
          console.log('the noticeDel has problem: ', err)
        })
    }
  }
}

export default dialogLogic
